import {
    Component,
    inject,
    Input,
    signal,
    WritableSignal,
} from '@angular/core';
import {
    ControlContainer,
    FormControl,
    ReactiveFormsModule,
} from '@angular/forms';
import { MatSelectModule } from '@angular/material/select';
import { TranslatePipe } from '@ngx-translate/core';
import { ElementWithOptionsModel } from '../../../models/clientsform/element-with-options';
import { LanguageCode } from '../../../models/language-code';
import { LocaleService } from '../../../services/locale.service';
import { FlagComponent } from '../../flag/flag.component';
import { TranslationComponent } from '../../translation/translation.component';

@Component({
    selector: 'apcam-language-select-element',
    imports: [
        FlagComponent,
        MatSelectModule,
        ReactiveFormsModule,
        TranslatePipe,
        TranslationComponent,
    ],
    templateUrl: './language-select-element.component.html',
    styleUrl: './language-select-element.component.scss',
    viewProviders: [
        {
            provide: ControlContainer,
            useFactory: () => inject(ControlContainer, { skipSelf: true }),
        },
    ],
})
export class LanguageSelectElementComponent {
    @Input({ required: true })
    public formcontrolName!: string;

    @Input({ required: true })
    public inputConfig!: ElementWithOptionsModel;

    @Input({ required: true })
    public supportedLanguages: WritableSignal<LanguageCode[]> = signal([]);

    protected get input() {
        return this.controlContainer.control?.get([
            this.formcontrolName,
        ]) as FormControl;
    }

    protected readonly LocaleService = LocaleService;
    protected selectedLanguage: LanguageCode | null = null;

    private readonly controlContainer = inject(ControlContainer);
}
